<script>
	import { loadingPopupFlag, loadingMessage } from './../store/loadingPopupStore.js';
</script>

<div class="image-loading-popup2" class:show={$loadingPopupFlag}>
  <div class="popup-layer loading">
    <div class="bring-image">
      <div class="spinner"></div>
      <div>{$loadingMessage}</div>
    </div>
  </div>
</div>

<style>
	@keyframes spinner {
        to {
            transform: rotate(360deg);
        }
    }

    .spinner:before {
        position: absolute;
        left: 53px;
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 40%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        border-radius: 50%;
        border-top: 2px solid hsl(var(--sb-primary));
        border-right: 2px solid transparent;
        animation: spinner .7s linear infinite;
        animation-iteration-count: 50;
    }
</style>